/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as TeamDefs from './defs.defs.js'

const $nsid = 'tools.ozone.team.listMembers'

export { $nsid }

/** List all members with access to the ozone service. */
const main = l.query(
  $nsid,
  l.params({
    q: l.optional(l.string()),
    disabled: l.optional(l.boolean()),
    roles: l.optional(l.array(l.string())),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    members: l.array(l.ref<TeamDefs.Member>((() => TeamDefs.member) as any)),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
